(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ck-pdp-fulfilment-band"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__ckFulfilmentInit) return;
    root.__ckFulfilmentInit = true;

    const slides = Array.from(root.querySelectorAll('.ck-pdp-fulfilment__slide'));
    const controls = Array.from(root.querySelectorAll('.ck-pdp-fulfilment__control'));
    if (slides.length < 2 || controls.length < 2) return;

    const duration = parseInt(root.dataset.slideDuration || '7000', 10);
    const pauseOnHover = root.dataset.pauseOnHover !== '0';

    // Expose slide duration for CSS animation
    root.style.setProperty('--ck-slide-duration', (duration / 1000) + 's');

    let current = 0;
    let timer = null;
    let paused = false;

    function show(idx) {
      if (idx === current) return;
      slides[current].classList.remove('is-active');
      controls[current].classList.remove('is-active');
      controls[current].setAttribute('aria-selected', 'false');

      current = idx;
      slides[current].classList.add('is-active');
      controls[current].classList.add('is-active');
      controls[current].setAttribute('aria-selected', 'true');

      // Restart the timer animation on the new active control
      const t = controls[current].querySelector('.ck-pdp-fulfilment__control-timer');
      if (t) {
        const after = window.getComputedStyle(t, '::after');
        // Force animation restart by toggling the parent class
        t.style.animation = 'none';
        void t.offsetWidth;
        t.style.animation = '';
      }
    }

    function next() { show((current + 1) % slides.length); }
    function start() { stop(); if (!paused) timer = setInterval(next, duration); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    controls.forEach((c, i) => c.addEventListener('click', () => { show(i); start(); }));

    if (pauseOnHover) {
      root.addEventListener('mouseenter', () => { paused = true; root.classList.add('is-paused'); stop(); });
      root.addEventListener('mouseleave', () => { paused = false; root.classList.remove('is-paused'); start(); });
    }

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!prefersReduced.matches) start();
  }

  document.querySelectorAll('[data-ck-fulfilment]').forEach(init);

  // Re-init on theme editor section reload
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-ck-fulfilment]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-ck-pdp-reviews]');
    if (!root || root.dataset.ckBound === '1') return;
    root.dataset.ckBound = '1';

    var featuredWrap = root.querySelector('[data-featured]');
    var grid = root.querySelector('[data-grid]');
    var bars = root.querySelectorAll('[data-bar-star]');
    var gridSearch = root.querySelector('[data-grid-search]');
    var gridSort = root.querySelector('[data-grid-sort]');
    var gridMore = root.querySelector('[data-grid-more]');
    var source = root.querySelector('.ck-pdp-reviews__jdgm-source');

    var allReviews = [];
    var gridPage = 1;
    var gridPageSize = 6;

    function parseJdgmDom() {
      var scope = source || document;
      var revs = scope.querySelectorAll('.jdgm-rev');
      if (!revs.length && source) {
        revs = document.querySelectorAll('.jdgm-rev');
      }
      return Array.from(revs).map(function (el) {
        var rating = parseInt(el.getAttribute('data-score') || '5', 10);
        var title = (el.querySelector('.jdgm-rev__title') || {}).textContent || '';
        // Strip Judge.me's "Read more" link fragment from body
        var bodyEl = el.querySelector('.jdgm-rev__body');
        var body = '';
        if (bodyEl) {
          var bodyClone = bodyEl.cloneNode(true);
          bodyClone.querySelectorAll('.jdgm-rev__read-more, a, .jdgm-rev__read-less').forEach(function (a) { a.remove(); });
          body = bodyClone.textContent || '';
        }
        var author = (el.querySelector('.jdgm-rev__author') || {}).textContent || 'Anonymous';
        var location = (el.querySelector('.jdgm-rev__location') || {}).textContent || '';
        var ts = el.querySelector('.jdgm-rev__timestamp');
        var iso = ts ? (ts.getAttribute('data-content') || ts.textContent || '') : '';
        var photos = Array.from(el.querySelectorAll('.jdgm-rev__pic img, .jdgm-rev__pics img')).map(function (img) {
          return img.getAttribute('data-src') || img.getAttribute('src') || '';
        }).filter(Boolean);
        var verified = !!el.querySelector('.jdgm-rev__verified-badge, .jdgm-rev__verified-icon');
        var helpfulEl = el.querySelector('.jdgm-rev__thumbs-up-count, [data-thumbs-up-count]');
        var helpful = helpfulEl ? parseInt(helpfulEl.textContent || '0', 10) : 0;
        var replyEl = el.querySelector('.jdgm-rev__reply, .jdgm-rev__reply-body');
        var reply = '';
        if (replyEl) {
          var replyClone = replyEl.cloneNode(true);
          replyClone.querySelectorAll('a.jdgm-rev__read-more, a.jdgm-rev__read-less').forEach(function (a) { a.remove(); });
          reply = (replyClone.textContent || '').trim();
        }
        var sourceBadge = (el.querySelector('.jdgm-rev__source-badge, .jdgm-rev__verified-badge') || {}).textContent || '';
        return {
          rating: rating,
          title: title.trim(),
          body: body.trim().replace(/\s*Read more\s*$/, '').replace(/\s*Read less\s*$/, ''),
          author: author.trim(),
          location: location.trim(),
          date_iso: iso.trim(),
          date_human: humanDate(iso.trim()),
          date_relative: relativeDate(iso.trim()),
          photos: photos,
          photo: photos[0] || '',
          verified: verified,
          helpful: helpful,
          reply: reply,
          source_badge: sourceBadge.trim(),
        };
      });
    }

    function humanDate(iso) {
      if (!iso) return '';
      // Judge.me hands us "2023-07-14 04:36:43 UTC" which new Date() can't parse reliably.
      // Normalise: replace space between date and time with T, and " UTC" suffix with Z.
      var normalized = iso.replace(/^(\d{4}-\d{2}-\d{2}) /, '$1T').replace(/\s*UTC\s*$/, 'Z');
      var d = new Date(normalized);
      if (isNaN(d.getTime())) d = new Date(iso);
      if (isNaN(d.getTime())) return iso;
      try {
        return d.toLocaleDateString('en-AU', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        });
      } catch (e) {
        return d.toDateString();
      }
    }

    function relativeDate(iso) {
      if (!iso) return '';
      var normalized = iso.replace(/^(\d{4}-\d{2}-\d{2}) /, '$1T').replace(/\s*UTC\s*$/, 'Z');
      var d = new Date(normalized);
      if (isNaN(d.getTime())) return '';
      var now = Date.now();
      var diff = now - d.getTime();
      var day = 86400000;
      var days = Math.floor(diff / day);
      if (days < 1) return 'today';
      if (days < 2) return 'yesterday';
      if (days < 7) return days + ' days ago';
      if (days < 30) return Math.floor(days / 7) + ' weeks ago';
      if (days < 365) return Math.floor(days / 30) + ' months ago';
      var years = Math.floor(days / 365);
      return years + ' year' + (years === 1 ? '' : 's') + ' ago';
    }

    function extractPullQuote(body, title) {
      if (title && title.length > 3 && title.length < 80) return title;
      var sentences = body.split(/(?<=[.!?])\s+/);
      for (var i = 0; i < sentences.length; i++) {
        var s = sentences[i].trim();
        if (s.length >= 12 && s.length <= 110) return s;
      }
      return (body || '').slice(0, 110).trim() + (body.length > 110 ? '…' : '');
    }

    function renderStars(rating) {
      var pct = Math.max(0, Math.min(5, rating)) * 20;
      return '<span class="ck-pdp-reviews__cinema-card__stars" aria-hidden="true">' +
             '<span class="ck-pdp-reviews__cinema-card__stars-track"></span>' +
             '<span class="ck-pdp-reviews__cinema-card__stars-fill" style="width:' + pct + '%"></span>' +
             '</span>';
    }

    function renderFeaturedStars(rating) {
      var pct = Math.max(0, Math.min(5, rating)) * 20;
      return '<span class="ck-pdp-reviews__featured-card__stars" aria-hidden="true">' +
             '<span class="ck-pdp-reviews__featured-card__stars-track"></span>' +
             '<span class="ck-pdp-reviews__featured-card__stars-fill" style="width:' + pct + '%"></span>' +
             '</span>';
    }

    function renderFeaturedCard(r) {
      /* Editorial quote-only treatment: pull the strongest line, drop body/meta/photo/stars.
         Title is the punchiest signal in most Judge.me reviews ("Best line ever"); fall back
         to the first quotable sentence in the body. Attribution kept as a single small line. */
      var pull = extractPullQuote(r.body, r.title);
      return '<article class="ck-pdp-reviews__featured-card">' +
             '<p class="ck-pdp-reviews__featured-card__pullquote">' + escapeHtml(pull) + '</p>' +
             '</article>';
    }

    function renderGridCard(r) {
      var metaParts = [
        '<span class="ck-pdp-reviews__grid-card__author">' + escapeHtml(r.author) + '</span>',
      ];
      if (r.location) metaParts.push('<span class="ck-pdp-reviews__grid-card__location">' + escapeHtml(r.location) + '</span>');
      if (r.verified) metaParts.push('<span class="ck-pdp-reviews__grid-card__verified"><svg width="11" height="11" viewBox="0 0 12 12" aria-hidden="true"><path d="M2.5 6.5 L5 9 L9.5 3.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>Verified purchase</span>');

      var contentParts = [];
      contentParts.push(
        '<div class="ck-pdp-reviews__grid-card__stars-row">' +
        renderStars(r.rating) +
        '<span class="ck-pdp-reviews__grid-card__rating-value">(' + r.rating + ')</span>' +
        '</div>'
      );
      if (r.title) contentParts.push('<h4 class="ck-pdp-reviews__grid-card__title">' + escapeHtml(r.title) + '</h4>');
      contentParts.push('<p class="ck-pdp-reviews__grid-card__body">' + escapeHtml(r.body) + '</p>');

      if (r.photos && r.photos.length) {
        var photoHtml = r.photos.map(function (p) {
          return '<div class="ck-pdp-reviews__grid-card__photo" data-photo-src="' + p + '" role="button" tabindex="0" aria-label="View larger" style="background-image:url(\'' + p + '\')"></div>';
        }).join('');
        contentParts.push('<div class="ck-pdp-reviews__grid-card__photos">' + photoHtml + '</div>');
      }

      if (r.reply) {
        contentParts.push(
          '<div class="ck-pdp-reviews__grid-card__reply">' +
          '<span class="ck-pdp-reviews__grid-card__reply-label">Reply from Salonshop</span>' +
          '<p class="ck-pdp-reviews__grid-card__reply-body">' + escapeHtml(r.reply) + '</p>' +
          '</div>'
        );
      }

      var footerParts = [];
      if (r.date_relative) footerParts.push('<span class="ck-pdp-reviews__grid-card__date-relative">' + escapeHtml(r.date_relative) + '</span>');
      if (r.date_human) footerParts.push('<span class="ck-pdp-reviews__grid-card__date">' + escapeHtml(r.date_human) + '</span>');
      if (r.helpful > 0) footerParts.push('<span class="ck-pdp-reviews__grid-card__helpful">' + r.helpful + ' found this helpful</span>');
      if (r.source_badge) footerParts.push('<span class="ck-pdp-reviews__grid-card__source">' + escapeHtml(r.source_badge) + '</span>');
      if (footerParts.length) {
        contentParts.push('<div class="ck-pdp-reviews__grid-card__footer">' + footerParts.join('<span class="ck-pdp-reviews__grid-card__footer-dot">·</span>') + '</div>');
      }

      return '<article class="ck-pdp-reviews__grid-card">' +
             '<div class="ck-pdp-reviews__grid-card__meta">' + metaParts.join('') + '</div>' +
             '<div class="ck-pdp-reviews__grid-card__content">' + contentParts.join('') + '</div>' +
             '</article>';
    }

    function escapeHtml(s) {
      return (s || '').replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    function trimWords(s, n) {
      var words = s.split(/\s+/);
      if (words.length <= n) return s;
      return words.slice(0, n).join(' ') + '…';
    }

    function extractAllPhrases(body, title) {
      /* Pull every quotable phrase from a review.
         Body sentences (4-16 words, ≥ 18 chars) score better than titles. */
      var phrases = [];
      if (body) {
        var sentences = body
          .replace(/\s+/g, ' ')
          .split(/(?<=[.!?])\s+(?=[A-Z])/);
        for (var i = 0; i < sentences.length; i++) {
          var s = sentences[i].trim().replace(/^["'“”]+|["'“”]+$/g, '');
          var wc = s.split(/\s+/).filter(Boolean).length;
          if (wc >= 4 && wc <= 16 && s.length >= 18 && s.length <= 130) {
            phrases.push(s);
          }
        }
      }
      if (title) {
        var t = title.trim().replace(/^["'“”]+|["'“”]+$/g, '');
        var twc = t.split(/\s+/).filter(Boolean).length;
        if (twc >= 2 && t.length >= 8 && t.length <= 80) {
          phrases.push(t);
        }
      }
      return phrases;
    }

    /* Voice/sentiment words that signal a phrase is a real quote, not a product
       descriptor. STRICT list — only words rarely seen in product names.
       Excludes: soft, smooth, shiny, healthy, dry, oily, scalp, hair, gentle,
       would, will, can, could, should, more, less, since (all common in
       marketing copy and product titles). */
    var VOICE_WORDS = {
      i:1, my:1, me:1, mine:1, we:1, us:1, our:1, ours:1,
      you:1, your:1, yours:1, he:1, she:1, his:1, her:1, hers:1,
      this:1, that:1, these:1, those:1, it:1, its:1,
      love:1, loved:1, loves:1, hate:1, hated:1, hates:1, like:1, liked:1, likes:1,
      feel:1, feels:1, felt:1, use:1, used:1, uses:1, using:1,
      work:1, works:1, worked:1, working:1,
      recommend:1, recommended:1, recommends:1, tried:1, trying:1, tries:1,
      smells:1, leaves:1, makes:1, helps:1, helped:1, keeps:1, kept:1,
      fixes:1, fixed:1, gives:1, gave:1, brings:1, brought:1,
      amazing:1, awesome:1, perfect:1, best:1, better:1, worst:1, great:1,
      fantastic:1, terrible:1, awful:1, brilliant:1, lovely:1, wonderful:1,
      gorgeous:1, stunning:1, fabulous:1, good:1, bad:1,
      ever:1, never:1, always:1, after:1, before:1, again:1, every:1,
      everyday:1, daily:1, really:1, very:1, just:1
    };

    function tokenize(s) {
      return (s || '')
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, ' ')
        .split(/\s+/)
        .filter(function (t) { return t.length >= 2; });
    }

    function looksLikeProductTitle(phrase, productTitleTokens) {
      /* True if phrase reads as a product-name variant rather than a quote.
         Detects phrases like "Muk Ultra soft shampoo" or "Muk Deep" that share
         most tokens with the product title and lack any first-person/sentiment
         words. Real quotes ("Best ever", "Gentle on my hair") survive. */
      if (!productTitleTokens.length) return false;
      var tokens = tokenize(phrase);
      if (!tokens.length) return false;
      for (var i = 0; i < tokens.length; i++) {
        if (VOICE_WORDS[tokens[i]]) return false;
      }
      var titleSet = Object.create(null);
      productTitleTokens.forEach(function (t) { if (t.length >= 3) titleSet[t] = true; });
      var meaningful = tokens.filter(function (t) { return t.length >= 3; });
      if (!meaningful.length) return false;
      var overlap = 0;
      for (var j = 0; j < meaningful.length; j++) {
        if (titleSet[meaningful[j]]) overlap++;
      }
      return (overlap / meaningful.length) >= 0.6;
    }

    function pickPhrases(reviews, max) {
      /* One phrase per reviewer (dedupe by author). Skip phrases that read as
         product-name variants. Body sentences prioritised over review titles
         by extractAllPhrases ordering. */
      var productTitleTokens = tokenize(root.dataset.productTitle || '');
      var picks = [];
      var seenAuthors = Object.create(null);
      var seenText = Object.create(null);
      reviews.forEach(function (r) {
        var authorKey = (r.author || 'anonymous').toLowerCase().trim();
        if (seenAuthors[authorKey]) return;
        var phrases = extractAllPhrases(r.body, r.title);
        for (var i = 0; i < phrases.length; i++) {
          var p = phrases[i];
          if (looksLikeProductTitle(p, productTitleTokens)) continue;
          var textKey = p.toLowerCase().replace(/\s+/g, ' ').trim().slice(0, 28);
          if (seenText[textKey]) continue;
          seenText[textKey] = true;
          seenAuthors[authorKey] = true;
          picks.push({ text: p, author: r.author || '', rating: r.rating });
          break;
        }
      });
      return picks.slice(0, max);
    }

    function renderFeatured(reviews) {
      if (!featuredWrap) return;
      if (reviews.length < 1) {
        featuredWrap.style.display = 'none';
        return;
      }
      featuredWrap.style.display = '';
      featuredWrap.classList.add('ck-pdp-reviews__featured--chorus');

      var phrases = pickPhrases(reviews, 6);
      if (phrases.length < 1) { featuredWrap.style.display = 'none'; return; }

      /* Insert an incentive bubble at index 2 (or end if shorter) when ≥3 phrases */
      var html = phrases.map(renderChorusBubble).join('');
      if (phrases.length >= 3) {
        var insertAt = Math.min(2, phrases.length);
        var bubbles = phrases.map(renderChorusBubble);
        bubbles.splice(insertAt, 0, renderIncentiveBubble());
        html = bubbles.join('');
      } else {
        html = html + renderIncentiveBubble();
      }

      /* Left-align when ≤2 phrases, centred-fill when more */
      featuredWrap.classList.toggle('ck-pdp-reviews__featured--sparse', phrases.length <= 2);
      featuredWrap.innerHTML = html;
    }

    function renderChorusBubble(phrase, i) {
      var idx = (typeof i === 'number') ? i : 0;
      var len = phrase.text.length;
      var size = len < 32 ? 'sm' : len < 70 ? 'md' : 'lg';
      var tilt = ((idx * 37) % 5) - 2;
      var delay = (idx * 220) % 4000;
      return (
        '<div class="ck-pdp-reviews__chorus-item ck-pdp-reviews__chorus-item--' + size + '"' +
        ' data-rating="' + phrase.rating + '">' +
          '<div class="ck-pdp-reviews__chorus-bubble"' +
          ' style="--ck-bubble-tilt:' + tilt + 'deg; animation-delay:' + delay + 'ms">' +
            '<p class="ck-pdp-reviews__chorus-quote">' + escapeHtml(phrase.text) + '</p>' +
          '</div>' +
          (phrase.author ? '<span class="ck-pdp-reviews__chorus-author">' + escapeHtml(phrase.author) + '</span>' : '') +
        '</div>'
      );
    }

    function renderIncentiveBubble() {
      /* Editorial CTA bubble that lives among the customer quotes.
         Different visual register so it reads as an invitation, not a quote.
         Click-through wires to the existing Write a Review flow. */
      return (
        '<button type="button" class="ck-pdp-reviews__chorus-bubble ck-pdp-reviews__chorus-bubble--incentive"' +
        ' data-ck-write-review aria-label="Write a review">' +
        '<span class="ck-pdp-reviews__incentive-eyebrow">Stylist say</span>' +
        '<span class="ck-pdp-reviews__incentive-quote">Share your take, get a thank-you.</span>' +
        '<span class="ck-pdp-reviews__incentive-cta">Write a review →</span>' +
        '</button>'
      );
    }

    function renderBars(reviews) {
      if (!bars.length) return;
      var counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
      reviews.forEach(function (r) { if (counts[r.rating] !== undefined) counts[r.rating]++; });
      var total = reviews.length || 1;
      bars.forEach(function (row) {
        var star = parseInt(row.getAttribute('data-bar-star'), 10);
        var n = counts[star] || 0;
        var pct = (n / total) * 100;
        var fill = row.querySelector('.ck-pdp-reviews__bar-fill');
        var count = row.querySelector('[data-bar-count]');
        if (fill) fill.style.width = pct + '%';
        if (count) count.textContent = n;
      });
    }

    function applyGridFilters() {
      if (!grid) return;
      var q = (gridSearch && gridSearch.value || '').toLowerCase().trim();
      var sort = gridSort && gridSort.value || 'recent';
      var list = allReviews.slice();
      if (q) {
        list = list.filter(function (r) {
          return (r.body + ' ' + r.title + ' ' + r.author).toLowerCase().indexOf(q) !== -1;
        });
      }
      list.sort(function (a, b) {
        if (sort === 'highest') return b.rating - a.rating;
        if (sort === 'lowest') return a.rating - b.rating;
        if (sort === 'pictures') return (!!b.photo) - (!!a.photo);
        return 0; // recent = preserve original order from Judge.me (newest first)
      });
      var visible = list.slice(0, gridPage * gridPageSize);
      grid.innerHTML = visible.map(renderGridCard).join('');
      if (gridMore) {
        gridMore.style.display = list.length > visible.length ? '' : 'none';
      }
    }

    function boot(reviews) {
      allReviews = reviews;
      renderFeatured(reviews);
      renderBars(reviews);
      applyGridFilters();
    }

    // Wait for Judge.me widget to populate. Poll every 400ms up to 8s.
    var tries = 0;
    var maxTries = 20;
    function tick() {
      var reviews = parseJdgmDom();
      if (reviews.length > 0 || tries >= maxTries) {
        boot(reviews);
        return;
      }
      tries++;
      setTimeout(tick, 400);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tick);
    } else {
      setTimeout(tick, 800); // initial delay for Judge.me to start mounting
    }

    // Resilient re-ingest: Judge.me can finish hydrating AFTER the 8s poll window
    // (slow networks, or the hidden source widget mounting empty first), which left
    // products with real reviews showing "Be the first". Watch for .jdgm-rev nodes
    // appearing and re-boot whenever the count grows. Debounced; self-stops after 30s.
    var ckLastRevCount = 0, ckPending = false;
    function ckCheckReviews() {
      ckPending = false;
      var n = document.querySelectorAll('.jdgm-rev').length;
      if (n > ckLastRevCount) { ckLastRevCount = n; boot(parseJdgmDom()); }
    }
    var ckReingest = new MutationObserver(function () {
      if (ckPending) return;
      ckPending = true;
      setTimeout(ckCheckReviews, 150);
    });
    try { ckReingest.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    setTimeout(function () { ckReingest.disconnect(); }, 30000);

    if (gridSearch) gridSearch.addEventListener('input', applyGridFilters);
    if (gridSort) gridSort.addEventListener('change', applyGridFilters);
    if (gridMore) gridMore.addEventListener('click', function () { gridPage++; applyGridFilters(); });

    /* Delegated: wires both the main Write CTA and dynamic incentive bubbles. */
    if (root) root.addEventListener('click', function (e) {
      var scrollBtn = e.target.closest && e.target.closest('[data-ck-scroll-to-form]');
      if (scrollBtn) {
        e.preventDefault();
        var form = document.querySelector('product-form, form[action*="/cart/add"]:not(.ck-pdp-reviews__cover-buyform), #MainContent, main');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        else window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      var writeBtn = e.target.closest && e.target.closest('[data-ck-write-review]');
      if (!writeBtn) return;
      e.preventDefault();
      handleWriteReview();
    });

    function handleWriteReview() {

        // Trigger Judge.me's internal link so their widget instantiates the form
        var jdgmLink = document.querySelector('.jdgm-write-rev-link');
        if (jdgmLink) jdgmLink.click();

        // Promote the form wrapper out of the hidden widget into a body-level modal
        setTimeout(function () {
          var wrapper = document.querySelector('.jdgm-form-wrapper');
          if (!wrapper) return;

          // Only move + wrap once
          if (!wrapper.dataset.ckPromoted) {
            var overlay = document.createElement('div');
            overlay.className = 'ck-pdp-reviews__modal-overlay';
            overlay.setAttribute('role', 'presentation');
            overlay.addEventListener('click', closeModal);

            var closeBtn = document.createElement('button');
            closeBtn.type = 'button';
            closeBtn.className = 'ck-pdp-reviews__modal-close';
            closeBtn.setAttribute('aria-label', 'Close review form');
            closeBtn.innerHTML = '&times;';
            closeBtn.addEventListener('click', closeModal);

            document.body.appendChild(overlay);
            document.body.appendChild(wrapper);
            wrapper.classList.add('ck-pdp-reviews__modal');
            wrapper.appendChild(closeBtn);
            wrapper.dataset.ckPromoted = '1';
          }

          openModal();
        }, 120);
    }

    function openModal() {
      var wrapper = document.querySelector('.ck-pdp-reviews__modal');
      var overlay = document.querySelector('.ck-pdp-reviews__modal-overlay');
      if (!wrapper || !overlay) return;
      wrapper.style.display = 'block';
      overlay.style.display = 'block';
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onEsc);
    }

    function closeModal() {
      var wrapper = document.querySelector('.ck-pdp-reviews__modal');
      var overlay = document.querySelector('.ck-pdp-reviews__modal-overlay');
      if (wrapper) wrapper.style.display = 'none';
      if (overlay) overlay.style.display = 'none';
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onEsc);
    }

    function onEsc(e) {
      if (e.key === 'Escape') closeModal();
    }

    /* ─── Review-photo lightbox ─── */
    var lightbox, lightboxImg, lightboxCounter, lightboxList = [], lightboxIdx = 0;

    function buildLightbox() {
      if (lightbox) return;
      lightbox = document.createElement('div');
      lightbox.className = 'ck-pdp-reviews__lightbox';
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');
      lightbox.setAttribute('aria-label', 'Customer photo');
      lightbox.innerHTML =
        '<button type="button" class="ck-pdp-reviews__lightbox-close" aria-label="Close">&times;</button>' +
        '<button type="button" class="ck-pdp-reviews__lightbox-nav ck-pdp-reviews__lightbox-nav--prev" aria-label="Previous photo">&larr;</button>' +
        '<img alt="">' +
        '<button type="button" class="ck-pdp-reviews__lightbox-nav ck-pdp-reviews__lightbox-nav--next" aria-label="Next photo">&rarr;</button>' +
        '<div class="ck-pdp-reviews__lightbox-counter"></div>';
      document.body.appendChild(lightbox);
      lightboxImg = lightbox.querySelector('img');
      lightboxCounter = lightbox.querySelector('.ck-pdp-reviews__lightbox-counter');
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target === lightboxImg) closeLightbox();
      });
      lightbox.querySelector('.ck-pdp-reviews__lightbox-close').addEventListener('click', closeLightbox);
      lightbox.querySelector('.ck-pdp-reviews__lightbox-nav--prev').addEventListener('click', function (e) {
        e.stopPropagation(); stepLightbox(-1);
      });
      lightbox.querySelector('.ck-pdp-reviews__lightbox-nav--next').addEventListener('click', function (e) {
        e.stopPropagation(); stepLightbox(1);
      });
    }

    function upscalePhoto(url) {
      /* Judge.me serves 160px thumbnails via imgix. Upgrade to high-res by
         stripping the w/h params and re-adding w=1600. The "original" is at
         the path but query params constrain delivered size. */
      if (!url) return url;
      if (/imgix/.test(url)) {
        var u = url.replace(/[?&](w|h|fit|crop)=[^&]*/g, '');
        var sep = u.indexOf('?') >= 0 ? '&' : '?';
        return u + sep + 'auto=format&w=1600';
      }
      return url;
    }

    function showLightboxAt(i) {
      if (!lightboxList.length) return;
      lightboxIdx = (i + lightboxList.length) % lightboxList.length;
      lightboxImg.src = upscalePhoto(lightboxList[lightboxIdx]);
      lightboxCounter.textContent = lightboxList.length > 1
        ? (lightboxIdx + 1) + ' / ' + lightboxList.length
        : '';
      var nav = lightbox.querySelectorAll('.ck-pdp-reviews__lightbox-nav');
      nav.forEach(function (n) { n.style.display = lightboxList.length > 1 ? '' : 'none'; });
    }

    function stepLightbox(delta) { showLightboxAt(lightboxIdx + delta); }

    function openLightbox(srcList, startIdx) {
      buildLightbox();
      lightboxList = srcList.slice();
      showLightboxAt(startIdx || 0);
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onLightboxKey);
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onLightboxKey);
    }

    function onLightboxKey(e) {
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') stepLightbox(-1);
      else if (e.key === 'ArrowRight') stepLightbox(1);
    }

    /* Delegated click on the grid wrapper for any photo tile */
    if (root) {
      root.addEventListener('click', function (e) {
        var photo = e.target.closest && e.target.closest('.ck-pdp-reviews__grid-card__photo[data-photo-src]');
        if (!photo) return;
        e.preventDefault();
        var card = photo.closest('.ck-pdp-reviews__grid-card__photos');
        var photos = card
          ? Array.from(card.querySelectorAll('[data-photo-src]')).map(function (el) { return el.getAttribute('data-photo-src'); })
          : [photo.getAttribute('data-photo-src')];
        var idx = card ? Array.from(card.querySelectorAll('[data-photo-src]')).indexOf(photo) : 0;
        openLightbox(photos, Math.max(0, idx));
      });
      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var photo = e.target.closest && e.target.closest('.ck-pdp-reviews__grid-card__photo[data-photo-src]');
        if (!photo) return;
        e.preventDefault();
        photo.click();
      });
    }

    // ─── 3.0 Broadcast cover-story motion (28 Apr night) ───
    // Scroll-tied parallax + IntersectionObserver entrance triggers.
    // 4 cards on different wavelengths + per-text micro-parallax + badge postmark
    // fires LAST when section is fully in view.
    (function initCoverMotion() {
      var cover = root.querySelector('[data-ck-cover]');
      if (!cover) return;

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) {
        cover.classList.add('is-revealed', 'is-fully-revealed');
        cover.querySelectorAll('[data-stars-fill]').forEach(function (el) {
          el.style.width = (el.getAttribute('data-fill-pct') || 0) + '%';
        });
        return;
      }

      var pllElements = Array.from(cover.querySelectorAll('[data-pll], [data-pll-text]'));
      var ticking = false;

      // Once-per-session keepy-upy: badge drops from top, bounces, settles. After first
      // viewing, sessionStorage flag suppresses; subsequent views use plain postmark transition.
      try {
        if (!sessionStorage.getItem('ck-stylist-keepyupy-seen')) {
          var badgeEl = cover.querySelector('[data-badge-postmark]');
          if (badgeEl) badgeEl.classList.add('ck-bounce-eligible');
          sessionStorage.setItem('ck-stylist-keepyupy-seen', '1');
        }
      } catch (e) { /* sessionStorage may be blocked in private mode — silently skip */ }

      function applyParallax() {
        ticking = false;
        var rect = cover.getBoundingClientRect();
        var vh = window.innerHeight;
        // Progress: 0 when section's top is at viewport bottom, 1 when section's bottom is at viewport top.
        // Mapped to a centered range so transforms peak when section is mid-viewport.
        var sectionMid = rect.top + rect.height / 2;
        var viewportMid = vh / 2;
        var deltaPx = sectionMid - viewportMid; // negative when section is below middle, positive when above
        // Cap range so transforms don't stack absurdly off-screen.
        var maxRange = vh * 0.8;
        var t = Math.max(-1, Math.min(1, deltaPx / maxRange));
        // t = -1: section entering bottom of viewport, +1: leaving top.
        for (var i = 0; i < pllElements.length; i++) {
          var el = pllElements[i];
          var speed = parseFloat(el.getAttribute('data-pll')) || parseFloat(el.getAttribute('data-pll-text')) || 0;
          var translate = t * speed * 100; // pixels
          el.style.transform = 'translate3d(0,' + translate.toFixed(1) + 'px,0)';
        }
      }

      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(applyParallax);
          ticking = true;
        }
      }

      // Entrance observer: 30% in view → reveal cards + animate stars fill.
      // Then secondary trigger at 65% in view → fully-revealed → badge postmark thumps in.
      var revealed = false;
      var fullyRevealed = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var ratio = entry.intersectionRatio;
          if (ratio >= 0.5 && !revealed) {
            revealed = true;
            cover.classList.add('is-revealed');
            // Trigger stars fill width animation by setting target width.
            cover.querySelectorAll('[data-stars-fill]').forEach(function (el) {
              el.style.width = (el.getAttribute('data-fill-pct') || 0) + '%';
            });
          }
          if (ratio >= 0.65 && !fullyRevealed) {
            fullyRevealed = true;
            cover.classList.add('is-fully-revealed');
            io.unobserve(cover);
          }
        });
      }, { threshold: [0, 0.3, 0.5, 0.65, 0.85] });

      io.observe(cover);
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      applyParallax();
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    if (window.__ckPdpTaglineMoreBound) return;
    window.__ckPdpTaglineMoreBound = true;

    var prevScrollY = null;

    function findDescriptionTarget() {
      var editorial = document.getElementById('ck-pdp-description');
      if (editorial) {
        return {
          el: editorial,
          isOpen: function () { return editorial.tagName === 'DETAILS' ? !!editorial.open : false; },
          open: function () { if (editorial.tagName === 'DETAILS') editorial.open = true; },
          close: function () { if (editorial.tagName === 'DETAILS') editorial.open = false; }
        };
      }
      var tabs = document.querySelectorAll('toggle-tab');
      for (var i = 0; i < tabs.length; i++) {
        var title = tabs[i].querySelector('[data-js-title], .toggle__title');
        if (title && /description/i.test(title.textContent)) {
          return {
            el: tabs[i],
            isOpen: function () { return title.getAttribute('aria-expanded') === 'true'; },
            open: function () {
              if (title.getAttribute('aria-expanded') !== 'true') title.click();
            },
            close: function () {
              if (title.getAttribute('aria-expanded') === 'true') title.click();
            }
          };
        }
      }
      return null;
    }

    function scrollToTarget(target) {
      var headerOffset = 80;
      var top = target.el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function setLinkState(expanded) {
      var links = document.querySelectorAll('[data-ck-open-description]');
      links.forEach(function (link) {
        link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        var label = link.querySelector('[data-ck-label]');
        if (label) label.textContent = expanded ? 'Hide description' : 'Full description';
      });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-ck-open-description]');
      if (!trigger) return;
      var target = findDescriptionTarget();
      if (!target) return;
      e.preventDefault();

      if (target.isOpen()) {
        target.close();
        setLinkState(false);
        if (prevScrollY != null) {
          window.scrollTo({ top: prevScrollY, behavior: 'smooth' });
          prevScrollY = null;
        } else {
          // fallback — scroll back to the link itself
          setTimeout(function () {
            var rect = trigger.getBoundingClientRect();
            var top = rect.top + window.pageYOffset - 120;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }, 30);
        }
        history.replaceState(null, '', location.pathname + location.search);
      } else {
        prevScrollY = window.pageYOffset;
        target.open();
        setLinkState(true);
        setTimeout(function () { scrollToTarget(target); }, 30);
        history.replaceState(null, '', '#ck-pdp-description');
      }
    });

    function handleHash() {
      if (location.hash !== '#ck-pdp-description') return;
      var target = findDescriptionTarget();
      if (!target) return;
      prevScrollY = 0;
      target.open();
      setLinkState(true);
      setTimeout(function () { scrollToTarget(target); }, 30);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handleHash);
    } else {
      handleHash();
    }
    window.addEventListener('hashchange', handleHash);
  })();

  // ck-pdp-rating — scroll-to-reviews click fallback
  (function () {
    if (window.__ckPdpRatingBound) return;
    window.__ckPdpRatingBound = true;
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-ck-scroll-to-reviews]');
      if (!link) return;
      var target = document.getElementById('ck-pdp-reviews')
        || document.getElementById('judgeme_product_reviews')
        || document.querySelector('.jdgm-widget, [data-ck-pdp-reviews]');
      if (!target) return;
      e.preventDefault();
      var headerOffset = 80;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
